import { initialState } from './reducer';

export interface IPaymentsStore {}

export function getInitialPaymentsStore(): IPaymentsStore {
  return { ...initialState };
}
